<template>
  <div class="personalParticulars">
    <p style="height: 30px;"><span @click="goBacks" class="el-icon-circle-close"
        style="float: right; font-size: 24px;"></span></p>
    <p style="font-size: 20px; font-weight: bold;">{{ ownerDate }}日{{ teacherName }}教师课消统计</p>
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column fixed prop="classTime" label="上课时间">
      </el-table-column>
      <el-table-column prop="studentName" label="学生姓名">
      </el-table-column>
      <el-table-column label="上课科目" prop="categoryName">
      </el-table-column>
      <el-table-column prop="classNum" label="课节数">
      </el-table-column>
      <el-table-column prop="classMoney" label="课消">
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="requestParameters.pageNum" :page-size="requestParameters.pageSize"
      layout="prev, pager, next,sizes, jumper" :total="total">
    </el-pagination>
  </div>
</template>

<script>
import axios from "axios";
import apiBaseUrl from "../../../config/api";
export default {
  data () {
    return {
      total:'',
      ownerDate: "",
      teacherId: "",
      teacherName: '',
      tableData: [],
      requestParameters: {
        pageSize: 10, //每页多少条
        pageNum: 1, //当前显示页码
      },
    }
  },
  mounted () {

  },
  created () {
    this.ownerDate = this.$route.params.time,
      this.teacherId = this.$route.params.id
    this.teacherName = this.$route.params.name
    this.getListData()
  },
  methods: {
    //关闭按钮
    goBacks () {
      history.go(-1)
    },
    handleSizeChange (pageSize) {
      this.requestParameters.pageSize = pageSize;
      if (this.requestParameters.page === 1) {

      }
      this.getListData(this.requestParameters);
    },
    // 进入某一页
    handleCurrentChange (newPage) {
      this.requestParameters.pageNum = newPage;
      this.getListData();
    },
    //根据日期查找每日所有老师的课消
    getListData () {
      let data = {
        ownerDate: this.ownerDate,
        teacherId: this.teacherId,
        pageNum: this.requestParameters.pageNum,
        pageSize: this.requestParameters.pageSize
      }
      axios
        .post(`${apiBaseUrl}/classSales/getClassSalesStudent`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then(res => {
          this.tableData = res.data.data.records
          this.total=res.data.data.total
        })
        .catch(error => {
          console.error(error);
        });
    },
  }
}
</script>

<style scoped>
@media screen and (max-width: 750px) {
  .personalParticulars {
    /* overflow: auto; */
    width: 1430px;
  }

  /* 兼容移动端 */
  #aa>>>.personalParticulars {
    width: 100% !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/manager/components/PersonalParticulars.vue